<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <!-- Tabel Utama (SOS) -->
      <div class="col-md-6">
        <div class="card" style="height: 100%">
          <div class="card-header py-3">
            <div class="row align-items-center">
              <div class="col-4">
                <h5 class="mb-0">SOS</h5>
              </div>
              <div class="col-4 d-flex justify-content-center">
                <IconField>
                  <InputIcon>
                    <i class="pi pi-search"></i>
                  </InputIcon>
                  <InputText
                    v-model="table.search"
                    type="text"
                    size="small"
                    placeholder="Type min 3 character"
                    class="rounded-pill"
                  />
                    <!-- @keyup="filterType" -->
                </IconField>
              </div>
            </div>
          </div>

          <div style="height: 450px; overflow-y: auto">
            <DataTable
              :value="table.data"
              scrollable
              scroll-height="flex"
              table-style="min-width: 40rem"
              :row-class="getRowClass"
              @row-click="selectItem"
            >
              <Column
                field="sos_header"
                header="SOS Header"
                header-class="bg-light text-dark"
                sortable
              />
              <Column
                field="sos_description"
                header="SOS Description"
                header-class="bg-light text-dark"
                sortable
              />
            </DataTable>
          </div>

          <div class="card-footer d-flex justify-content-between align-items-center">
            <BasePagination
              v-model="table.page"
              :page-count="table.page"
              size="sm"
              @click="changePage"
            />
            <p class="mb-0">
              {{ (table.page - 1) * table.page + table.data.length }} of {{ table.total }}
            </p>
          </div>
        </div>
      </div>

      <!-- Tabel Detail (Material Group) -->
      <div class="col-md-6">
        <div class="card" style="height: 100%">
          <div class="card-header py-3">
            <div class="row align-items-center justify-content-between">
              <div class="col-6">
                <h5 class="mb-0">Material Group</h5>
              </div>
              <!-- <div class="col-6 text-end">
                <span v-if="selectedDetail">Untuk SOS: <strong>{{ selectedDetail.sos_header }}</strong></span>
              </div> -->
            </div>
          </div>

          <div style="height: 450px; overflow-y: auto">
            <DataTable
              :value="tables.data"
              scrollable
              scroll-height="flex"
              table-style="min-width: 40rem"
            >
              <Column
                field="code"
                header="Code"
                header-class="bg-light text-dark"
                sortable
              />
              <Column
                field="description"
                header="Description"
                header-class="bg-light text-dark"
                sortable
              />
            </DataTable>
          </div>

          <div class="card-footer d-flex justify-content-between align-items-center">
            <BasePagination
              v-model="tables.page"
              :page-count="tables.page"
              size="sm"
              @click="changePage"
            />
            <p class="mb-0">
              {{ (tables.page - 1) * tables.page + tables.data.length }} of {{ tables.total }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      table: {
        search: "",
        page: 1,
        total: 3,
        data: [
          {
            sos_header: "010",
            sos_description: "ZA",
          },
          {
            sos_header: "011",
            sos_description: "Phosphate Rock",
          },
          {
            sos_header: "012",
            sos_description: "Urea",
          },
        ],
      },
      tables: {
        search: "",
        page: 1,
        total: 3,
        data: [], // Akan diisi ketika user klik baris
      },
      selectedDetail: null,
    };
  },
  methods: {
    selectItem(event) {
      const selected = event.data;
      this.selectedDetail = selected;

      // Dummy data detail berdasarkan sos_header
      switch (selected.sos_header) {
        case "010":
          this.tables.data = [
            { code: "ZA01", description: "ZA Material A" },
            { code: "ZA02", description: "ZA Material B" },
          ];
          break;
        case "011":
          this.tables.data = [
            { code: "PR01", description: "Phosphate Rock A" },
            { code: "PR02", description: "Phosphate Rock B" },
          ];
          break;
        case "012":
          this.tables.data = [
            { code: "UR01", description: "Urea Material A" },
            { code: "UR02", description: "Urea Material B" },
          ];
          break;
        default:
          this.tables.data = [];
      }
    },
    getRowClass(data) {
      return [
        "cursor-pointer",
        this.selectedDetail && this.selectedDetail.sos_header === data.sos_header
          ? "bg-warning text-white"
          : "",
      ];
    },
    // filterType() {
    //   console.log("🔎 Filtering based on search:", this.table.search);
    //   // Implementasi pencarian sesuai kebutuhan
    // },
    changePage() {
      // Placeholder untuk pagination
    },
  },
};
</script>
